import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { site } from '../data/site';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'orange' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'orange',
  href = site.checkoutUrl
}: CTAButtonProps) {
  const colors = variant === 'orange' ? 'bg-brand-orange text-white hover:bg-[#d96513] focus-visible:ring-brand-orange' : 'bg-white text-brand-blue hover:bg-brand-cream focus-visible:ring-white';
  return <a href={href} className={`group inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-extrabold tracking-[0.06em] shadow-md transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-54" data-mp="2oy701txass87">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-55" data-mp="38q3ld20djilw" />
    </a>;
}